export default [
  'Apfel',
  'Bonbon',
  'Butter',
  'Hahn',
  'Hund',
  'Kartoffel',
  'kneifen',
  'Kuss',
  'Löwenzahn',
  'Ohrfeige',
  'Pfütze',
  'Puppe',
  'Quetschfleck',
  'Rücken',
  'Schaukeln (Verb)',
  'Sofa',
  'Zwiebel',
  'In',
  'gsi bin / bin gsi',
  'werden',
]
